export const uiTestMenuI18n = {
  uiTest: 'DEV TEST',
  uiTestPage: {
    title: 'DEV TEST',
    description:
      'Chạy test trên màn hình thật (đúng URL nghiệp vụ), thao tác như người dùng. Xong tự quay về trang này và báo kết quả.',
    scenarioNhomKhachHang: 'TEST nhóm khách hàng ({count} tính năng)',
    scenarioNhomKhachHangHint:
      'Mở màn thật — đọc DB, sinh 2 nhóm mới mỗi lần chạy, tìm/sửa/xóa theo dữ liệu hiện có.',
    runButton: 'Chạy',
    runAllButton: 'Start ALL',
    runGroupButton: 'Chạy nhóm',
    runNewTabButton: 'Tab mới',
    groupCount: '{n} kịch bản',
    runningOnPage: 'Đang chạy test trên màn hình thật…',
    runningLiveBanner: 'Đang test thao tác UI — sẽ quay về trang test khi hoàn tất',
    runningLiveBannerAll:
      'Start ALL — kịch bản {current}/{total} — sẽ quay về trang test khi hoàn tất',
    runAllResultTitle: 'Kết quả Start ALL',
    runAllResultSuccess: 'Hoàn tất {n} kịch bản — tất cả đạt',
    runAllResultPartial: 'Hoàn tất {n} kịch bản — {failed} kịch bản có lỗi',
    runAllScenarios: 'Kịch bản: {n}',
    runAllScenarioList: 'Từng kịch bản',
    runTitleNhomKhachHang: 'Kết quả TEST nhóm khách hàng',
    back: 'Quay lại danh sách test',
    running: 'Đang chạy',
    done: 'Hoàn tất',
    logTitle: 'Nhật ký chi tiết',
    featureTitle: 'Từng tính năng',
    resultModalTitle: 'Kết quả test thao tác UI',
    resultSuccess: 'Thành công',
    resultPartial: 'Hoàn tất một phần',
    resultFailed: 'Thất bại',
    resultPassed: 'Đạt: {n}',
    resultSkipped: 'Bỏ qua: {n}',
    resultFailedCount: 'Lỗi: {n}',
    resultTotal: 'Tổng: {n}',
    resultClose: 'Đóng',
    failed: 'Chạy test thao tác thất bại',
    unknownScenario: 'Kịch bản test không hợp lệ',
    importFilesSection: 'Tải file import test',
    importFilesSectionHint:
      'Sinh file Excel theo dữ liệu thật (full sản phẩm × bảng giá hiện có) để thử nhập.',
    importFilesDownload: 'Tải file',
    importFilesDownloading: 'Đang tạo…',
    importFilesSuccess: 'Đã tải {file} ({rows} hàng × {books} bảng giá)',
    importFilesFailed: 'Không tạo được file import test',
    importFiles: {
      bangGiaHangHoaTitle: 'Import bảng giá hàng hóa',
      bangGiaHangHoaHint:
        'Ma trận: mỗi dòng 1 mã hàng; cột từ thứ 3 = tên bảng giá hiện tại; giá test tự sinh.',
    },
  },
} as const
